import type { Permission } from './roles';

/**
 * Стартовый раздел после входа.
 *
 * Общий вход на доску смен встречал водителя, медработника и механика экраном
 * «Недостаточно прав»: доска требует права на весь парк, которого у них нет. Поэтому
 * стартовая страница выбирается по правам, а не задаётся одна для всех.
 *
 * Порядок значим — берётся первое совпадение, поэтому специальные кабинеты
 * (медосмотр, техосмотр, «Моя смена») стоят раньше общих списков.
 */
const LANDING_BY_PERMISSION: readonly { permission: Permission; path: string }[] = [
  { permission: 'medical:write', path: '/medic' },
  { permission: 'technical:write', path: '/mechanic' },
  { permission: 'shift:confirm', path: '/driver' },
  // Доска — для тех, кто ведёт день парка. `shift:read-all` есть и у механика с
  // медработником, поэтому их кабинеты стоят выше: иначе они попадали бы на доску.
  { permission: 'shift:write', path: '/board' },
  // Администратор ведёт справочники и учётные записи, а не день парка: `shift:read` у
  // него есть, и без этой строки он попадал бы в список чужих смен.
  { permission: 'directory:write', path: '/directories' },
  { permission: 'shift:read', path: '/shifts' },
  { permission: 'user:manage', path: '/users' },
];

/** Раздел справки открыт всем авторизованным — годится как последний рубеж. */
export const FALLBACK_LANDING = '/guide';

/**
 * Куда отправить пользователя после входа.
 * @param has проверка права: `can` из контекста авторизации.
 */
export function landingPath(has: (permission: Permission) => boolean): string {
  return LANDING_BY_PERMISSION.find((entry) => has(entry.permission))?.path ?? FALLBACK_LANDING;
}
